import {
  RecurrenceSchedule,
  RecurrenceScheduleFrequency
} from "@wingspanhq/wingspan-api-sdk";

const daysInUTCMonth = (year: number, month: number) =>
  new Date(Date.UTC(year, month + 1, 0)).getUTCDate();

const utcDay = (year: number, month: number, day: number) =>
  new Date(Date.UTC(year, month, day, 12));

export const selectorNaturalOccurrenceDate = (request: {
  schedule?: RecurrenceSchedule;
  index: number;
}): Date | undefined => {
  const anchorDate = request.schedule?.anchorDate;

  if (!anchorDate) {
    return undefined;
  }

  const steps = request.index * (request.schedule?.interval || 1);
  const year = anchorDate.getUTCFullYear();
  const month = anchorDate.getUTCMonth();
  const day = anchorDate.getUTCDate();

  switch (request.schedule?.frequency) {
    case RecurrenceScheduleFrequency.WEEKLY:
      return utcDay(year, month, day + steps * 7);

    case RecurrenceScheduleFrequency.MONTHLY: {
      const targetMonth = month + steps;
      const targetYear = year + Math.floor(targetMonth / 12);
      const normalisedMonth = ((targetMonth % 12) + 12) % 12;

      return utcDay(
        targetYear,
        normalisedMonth,
        Math.min(day, daysInUTCMonth(targetYear, normalisedMonth))
      );
    }

    default:
      return undefined;
  }
};
